"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ColorPicker_module_css_1 = __importDefault(require("../public/ColorPicker.module.css"));
const Color_1 = require("./Color");
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
// Color picker components
const ColorGradientArea_1 = require("./ColorGradientArea");
const ColorAlphaSlider_1 = require("./ColorAlphaSlider");
const ColorHueSlider_1 = require("./ColorHueSlider");
const HexInputField_1 = require("./HexInputField");
const AlphaInputField_1 = require("./AlphaInputField");
const ColorPalette_1 = require("./ColorPalette");
const ColorPicker = (props) => {
    const { placement = "auto", callback, hideColorPalette = false, hideAlpha = false, disabled = false, dataKey = "" } = props;
    let { hexa } = props;
    if (hexa.includes("rgba(")) {
        let tmpHexa = hexa.split("rgba(")[1];
        tmpHexa = tmpHexa.split(")")[0];
        let rgba = tmpHexa.split(", ").map(value => Number(value));
        let r = rgba[0].toString(16);
        let g = rgba[1].toString(16);
        let b = rgba[2].toString(16);
        if (rgba[0] < 16)
            r = '0' + r;
        if (rgba[1] < 16)
            g = '0' + g;
        if (rgba[2] < 16)
            b = '0' + b;
        const hex = '#' + r + g + b;
        let alpha = (Math.round(rgba[3] * 255)).toString(16).toUpperCase();
        alpha = alpha.length == 1 ? "0" + alpha : alpha;
        hexa = hex + alpha;
    }
    const updatePreview = (hexa) => { setHexaColor(hexa); };
    const [color] = (0, react_1.useState)(new Color_1.Color({ updatePreview: updatePreview, callback: callback, hexa: hideAlpha ? hexa.substring(0, 7) : hexa, dataKey: dataKey }));
    const [hexaColor, setHexaColor] = (0, react_1.useState)(color.getHexa());
    react_1.default.useEffect(() => {
        // This should only be called once when rendered.
        setHexaColor(color.getHexa());
    }, []);
    const revertColorChange = () => {
        color.revertColorChange();
    };
    const colorPicker = (react_1.default.createElement(react_bootstrap_1.Popover, { id: "color-picker-overlay", "data-cy": "colorPickerPopover" },
        react_1.default.createElement(react_bootstrap_1.Popover.Body, { className: `${ColorPicker_module_css_1.default.color_picker_base} p-0`, "data-testid": props.testid },
            react_1.default.createElement("div", { className: "d-flex flex-nowrap" + (hideAlpha ? " justify-content-around" : ""), style: { marginTop: "12px", marginLeft: "10px", marginRight: "10px" } },
                react_1.default.createElement(ColorGradientArea_1.GradientArea, { color: color }),
                react_1.default.createElement(ColorHueSlider_1.HueSlider, { color: color }),
                !hideAlpha && react_1.default.createElement(ColorAlphaSlider_1.AlphaSlider, { color: color })),
            react_1.default.createElement("div", { className: "d-flex flex-nowrap align-items-center", style: { marginTop: "5px", marginLeft: "10px" } },
                react_1.default.createElement(HexInputField_1.HexInputField, { color: color }),
                !hideAlpha && react_1.default.createElement(AlphaInputField_1.AlphaInputField, { color: color }),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCircle, color: color.getHexa(), style: { border: "1px solid #D2D2D2", width: "10px", height: "10px", borderRadius: "50%", marginLeft: hideAlpha ? "auto" : "13px" } }),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { "data-cy": "revertColorBtn", icon: pro_solid_svg_icons_1.faRotateLeft, color: "#165152", onClick: revertColorChange, style: { width: "12px", height: "12px", marginLeft: "10px", marginRight: "16px", cursor: "pointer" } })),
            !hideColorPalette && react_1.default.createElement(ColorPalette_1.ColorPalette, { color: color, colorPaletteColors: props.colorPaletteColors }))));
    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: placement, trigger: "click", rootClose: true, overlay: colorPicker }, props.customInputField && props.customInputField ||
        react_1.default.createElement("button", { className: `${ColorPicker_module_css_1.default.color_picker_input} d-flex flex-nowrap align-items-center`, disabled: disabled, "data-cy": "ColorPickerBtn" },
            react_1.default.createElement("div", { className: ColorPicker_module_css_1.default.color_picker_input_preview, style: { backgroundColor: hexaColor } }),
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleDown, color: "#165152", width: "20px", height: "12px" }))));
};
exports.default = ColorPicker;
